export default JSON.parse(`{"distPath":"img/meta/","themeColor":"#fff","tileColor":"#fff"}`);